import UseTerms from "./UseTerms";

export default UseTerms;